import { Box, Grid } from "@mui/material";
import {
  FilterNonIdeal,
  InnerWrapper,
  MainContainer,
  TitleAndActionBox,
} from "../../../common";
import { useContext, useEffect, useRef, useState } from "react";
import { LanguageContext } from "../../../../context/LanguageContext";
import AppTableFilters from "../../../common/AppTableFilters";
import {
  ITEMS_PER_PAGE,
  NEW_SORT,
  TABLE_FILTER_UNCATEGORIZED,
} from "../../../../constants";
import { useFiltersHandler } from "../../../../hooks/useFilterHandler";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../../../context/AuthContext";
import { buildFiltersConfig } from "../../../../utils";
import TableHeader from "./TableHeader";
import { useCategorizedList } from "../../../../hooks/useCategorizedList";
import ItemList from "./ItemList";
import { AppPagination } from "../../../../Libraries";
import ChangeCategoryModal from "./ChangeCategoryModal";
import { useSnackbar } from "../../../../context/SnackbarContext";
import { Sync } from "../../../../SyncService";
import NonIdealNew from "../../../common/NonIdealNew";

const CategorizedList = () => {
  const { user } = useAuthContext();
  const navigate = useNavigate();
  const [I18n] = useContext(LanguageContext);
  const { showSnackbar } = useSnackbar();
  const location = useLocation();
  const isFetchingRef = useRef(false);

  const [selectedTrans, setSelectedTrans] = useState();
  const [loading, setLoading] = useState(false);

  const title = location?.state?.category || I18n.uncategorized;
  const type = location?.state?.type;

  const {
    filters,
    appliedChips,
    handleFilterChange,
    handleRemoveChip,
    isResetFilter,
    setIsResetFilter,
    resetFilters,
    isAppliedFilter,
  } = useFiltersHandler(location?.state, I18n);
  const { business } = useAuthContext();
  const { totalInvoiceCount, invoiceList, handleInvoice, isLoading } =
    useCategorizedList({
      business,
      filters,
      category: title?.toLowerCase() == "uncategorized" ? "" : title,
    });



  useEffect(() => {
    if (type) {
      handleFilterChange("type", [type]);
    }
  }, [type]);

  const handleNewCall = async () => {
    await handleInvoice({
      offset: 0,
      limit: ITEMS_PER_PAGE,
    });
  };

  useEffect(() => {
    handleNewCall();
  }, [filters]);

  const handleChangeCategory = async (category) => {
    try {
      setLoading(true);
      await selectedTrans.updateInvoiceCategory(category);
      showSnackbar({ message: I18n.category_updated, severity: "success" });
      setLoading(false);
      setSelectedTrans(null);
      Sync(user.phone_number, navigate);
      handleNewCall();
    } catch (error) {
      setLoading(false);
    }
  };
  return (
    <MainContainer fluid className="quickSalePage">
      <Grid container>
        <Grid item md={12}>
          <TitleAndActionBox data={{ isBack: true, title }} />
          <InnerWrapper className="innerWrapper newInnerWrapper">
            <Box className={"AccountWrapper"}>
              <AppTableFilters
                filters={TABLE_FILTER_UNCATEGORIZED}
                onFilterChange={handleFilterChange}
                appliedChips={appliedChips}
                filterState={filters}
                onRemoveChip={(chip) => {
                  isFetchingRef.current = true;
                  handleRemoveChip(chip);
                }}
                isResetFilter={isResetFilter}
                setIsResetFilter={setIsResetFilter}
                filtersConfig={buildFiltersConfig(TABLE_FILTER_UNCATEGORIZED, [], null, [
                    { label: I18n.sale, value: "Sale" },
                    { label: I18n.expense, value: "Expense" },
                  ], I18n.search_by_reference_number, null, null, null, null, I18n)}
              />
              <TableHeader
                isAscending={filters.sort == "Oldest"}
                isAscendingType={filters.sort == NEW_SORT.SALE}
                disabled={!invoiceList?.length}
                handleSort={(tab) => {
                  handleFilterChange(
                    "sort",
                    tab == "type"
                      ? filters.sort == NEW_SORT.SALE
                        ? NEW_SORT.EXPENSE
                        : NEW_SORT.SALE
                      : filters.sort == "Oldest"
                        ? "Newest"
                        : "Oldest",
                  );
                }}
              />
              <Box
                className={`${"accountListBodyWarpper"} generic-scrollbar`}
                id="scrollableDiv"
              >
                {invoiceList?.length > 0 ? (
                  <AppPagination
                    data={{
                      handleNext: (e) => {
                        if (invoiceList.length < totalInvoiceCount) {
                          handleInvoice({
                            offset: invoiceList.length,
                            limit: ITEMS_PER_PAGE,
                          });
                        }
                      },
                      pageLoad: isLoading,
                      count: totalInvoiceCount,
                      list: invoiceList,
                      scrollableTarget: "scrollableDiv",
                    }}
                  >
                    {invoiceList.map((item, i) => (
                      <ItemList
                        key={i}
                        index={i}
                        item={item}
                        onSelect={() => setSelectedTrans(item)}
                        filters={filters}
                      />
                    ))}
                  </AppPagination>
                ) : isAppliedFilter && !isLoading ? (
                  <Box className="h-100">
                    <FilterNonIdeal
                      title={I18n.no_transactions_matching_those_filters}
                      subTitle={I18n.try_adjusting_filters}
                      subTitleTextOnClick={() => resetFilters()}
                      subTitleText={I18n.reset_small}
                    />
                  </Box>
                ) : !isLoading ? (
                  <NonIdealNew
                    title={I18n.no_uncategorized_transactions}
                    subtitle={I18n.all_sales_and_expenses_are_categorized}
                    loading={false}
                    disabledOne={false}
                    disabledTwo={false}
                  />
                ) : null}
              </Box>
            </Box>
          </InnerWrapper>
        </Grid>
      </Grid>
      {Boolean(selectedTrans) && (
        <ChangeCategoryModal
          open={Boolean(selectedTrans)}
          onClose={() => setSelectedTrans(null)}
          onConfirm={handleChangeCategory}
          value={selectedTrans?.category}
          type={selectedTrans?.type == "in" ? "sale" : "expense"}
          loading={loading}
        />
      )}
    </MainContainer>
  );
};
export default CategorizedList;
